export default __webpack_public_path__ + "images/ba4444c7e3ad7b1780ef96c37d8501ca.png";